import React from "react";
import { DataGrid } from '@mui/x-data-grid';
import {Box, createTheme, ThemeProvider } from "@mui/material";
import {Button} from "semantic-ui-react";

export const DataTable = ({rows, columns, pageSize, title, onExport, isMobile}) => {
  const localeText = {
    footerPaginationRowsPerPage: 'Lignes par page :',
    footerPaginationTotalRows: (visibleCount, totalCount) => `${visibleCount}–${totalCount} sur ${totalCount}`,
    MuiTablePagination: {
      labelRowsPerPage: 'Lignes par page :',
      labelDisplayedRows: ({ from, to, count }) => `${from}–${to} sur ${count}`,
    },
    noRowsLabel: 'Pas de lignes',
    footerRowSelected: (count) =>
      count > 1 ? `${count.toLocaleString()} lignes sélectionnées` : `${count.toLocaleString()} ligne sélectionnée`,
  };

  const theme = createTheme({
    typography: {
      fontSize: 11
    },
    components: {
      MuiDataGrid: {
        styleOverrides: {
          root: {
            '& .MuiDataGrid-row:nth-of-type(even)': {
              backgroundColor: '#f5f5f5',
            },
            '& .MuiDataGrid-row:nth-of-type(odd)': {
              backgroundColor: '#ffffff',
            },
          },
        },
      },
    },
  });

  return (
    <>
      <ThemeProvider theme={theme}>
      <div style={{width: isMobile ? '95%' : '40.5%', display:'inline-block', maxWidth: '650px' }} className={'tableContainer d-flex justify-content-center align-items-center'}>
        <Box>
        <div className="headerTable d-flex justify-content-between align-items-center" >
          <div style={{flex: 1, textAlign: 'center'}}>{title}</div>
          {onExport && (
              <Button
                className="exportTable w-25"
                onClick={onExport}
              >
                Export
              </Button>
            )}
          </div>
          <DataGrid
              style={{ maxHeight: '340px' }}
              rows={rows}
              columns={columns.filter((column) => column.field !== 'id')}
              initialState={{
                pagination: {
                  paginationModel: {
                    pageSize: 25,
                  },
                },
              }}
              pageSizeOptions={[5, 10, 25, { value: -1, label: 'Tout afficher' }]}
              pageSize={10}
              rowsPerPageOptions={[10]}
              rowHeight={25}
              localeText={localeText}
              paginationMode="client"
              sx={{
                backgroundColor: 'white',
                // This is to override the default height of the footer row
                '& .MuiDataGrid-footerContainer': {
                  height: '30px',
                  minHeight: '30px',
                },
                '.MuiDataGrid-columnHeaderTitle': {
                  fontWeight: 'bold !important',
                  overflow: 'visible !important',
                  color: 'black'
                }
              }}
          />
        </Box>
      </div>
      </ThemeProvider>
    </>
  );
}
